import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "../data/products";

export const Footer = () => (
    <footer className="bg-ink text-white blueprint-grid-dark" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
                <div className="flex items-center gap-3 mb-5">
                    <img src="/assets/logo.png" alt="Mamta Enterprises logo" className="w-12 h-12 object-cover rounded-full shrink-0" />
                    <span className="font-display font-semibold uppercase tracking-wide text-xl">Mamta Enterprises</span>
                </div>
                <p className="text-sm text-white/60 leading-relaxed max-w-xs">
                    India's trusted wholesale supplier of drywall screws, fasteners and drywall accessories. Serving contractors, retailers and distributors.
                </p>
            </div>
            <div>
                <h4 className="font-display uppercase tracking-[0.2em] text-sm text-brand mb-5">Navigate</h4>
                <ul className="space-y-3">
                    {[["/", "Home"], ["/products", "Products"], ["/about", "About Us"], ["/contact", "Contact Us"]].map(([to, label]) => (
                        <li key={to}>
                            <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-white/70 hover:text-white transition-colors uppercase tracking-wider">
                                {label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <h4 className="font-display uppercase tracking-[0.2em] text-sm text-brand mb-5">Reach Us</h4>
                <ul className="space-y-4 text-sm">
                    <li>
                        <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="flex items-center gap-3 text-white/70 hover:text-white transition-colors break-all">
                            <Mail className="w-4 h-4 shrink-0 text-brand" /> {CONTACT.email}
                        </a>
                    </li>
                    <li>
                        <a href={`tel:+91${CONTACT.phone}`} data-testid="footer-phone-link" className="flex items-center gap-3 text-white/70 hover:text-white transition-colors">
                            <Phone className="w-4 h-4 shrink-0 text-brand" /> +91 {CONTACT.phone}
                        </a>
                    </li>
                    <li className="flex items-center gap-3 text-white/70" data-testid="footer-location">
                        <MapPin className="w-4 h-4 shrink-0 text-brand" /> {CONTACT.location}
                    </li>
                </ul>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/40 uppercase tracking-[0.2em]">
                <span data-testid="footer-copyright">Mamta Enterprises — All rights reserved</span>
                <span>Wholesale only · Bulk orders</span>
            </div>
        </div>
    </footer>
);
